/**
 * Created by XuQiang on 2017/5/24.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Input, Tabs } from 'antd';
import { OPEN_LOGIN } from '../../utils/constants';

const TabPane = Tabs.TabPane;

export default class FindPassword extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.loginData.isFlag) {
      this.props.dispatch({ type: 'login/isFlag', isFlag: false });
      this.reSendInterval();
    }
    if (nextProps.loginData.msm.minutes < 0) {
      this.reSendInterval();
    }
  }

  reSendInterval() {
    if (this.props.loginData.msm.minutes < 0) {
      window.clearInterval(this.numInterval);
      this.props.dispatch({ type: 'login/setMsm', msm: { minutes: 61 } });
    } else if (
      this.props.loginData.msm.minutes > 0 &&
      this.props.loginData.msm.minutes < 61
    ) {
      this.numInterval = setInterval(() => {
        this.props.dispatch({ type: 'login/updateMsm' });
      }, 1000);
      this.props.dispatch({ type: 'login/isFlag', isFlag: false });
    }
  }

  render() {
    const { intl, loginData, dispatch } = this.props;
    const {
      findPassword,
      msm,
      domainName,
      account,
      checkCodeImg,
      checkCode,
      checkCodeVisible
    } = loginData;
    let reSend =
      msm.minutes > 60
        ? intl.formatMessage({ id: 'index_valid_code' })
        : intl.formatMessage({ id: 're_send' }) + `(${msm.minutes})`;

    return (
      <div className="fix-activate">
        <div className="activate-cont">
          <div className="activate-title">
            <FormattedMessage id="index_find_password" />
          </div>
          <Tabs type="card" animated={false}>
            <TabPane
              tab={intl.formatMessage({ id: 'index_tip_email_title' })}
              key="1"
            >
              <div className="activate-type">
                <i className="iconfont icon_username" />
                <Input
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'index_login_username'
                  })}
                  value={account}
                  maxLength="37"
                  onChange={e =>
                    dispatch({
                      type: 'login/update',
                      payload: { account: e.target.value }
                    })
                  }
                />
              </div>
              <div className="activate-type email-type">
                <div className="email-input">
                  <i className="iconfont icon-emailemail" />
                  <Input
                    type="mail"
                    placeholder={intl.formatMessage({ id: 'index_email' })}
                    defaultValue={findPassword.email}
                    onChange={t =>
                      dispatch({
                        type: 'login/setFindPassword',
                        findPassword: {
                          ...findPassword,
                          email: t.target.value,
                          tips: ''
                        }
                      })
                    }
                  />
                </div>
                <a
                  onClick={() =>
                    dispatch({ type: 'login/findPassword', flag: 0 })
                  }
                >
                  <FormattedMessage id="index_send" />
                </a>
              </div>
            </TabPane>
            <TabPane
              tab={intl.formatMessage({ id: 'index_valid_phone_title' })}
              key="2"
            >
              <div className="activate-type">
                <i className="iconfont icon_username" />
                <Input
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'index_login_username'
                  })}
                  value={account}
                  maxLength="37"
                  onChange={e =>
                    dispatch({
                      type: 'login/update',
                      payload: { account: e.target.value }
                    })
                  }
                />
              </div>
              <div className="activate-type mobile-type">
                <div className="mobile-input">
                  <i className="iconfont icon-mobile" />
                  <Input
                    type="tel"
                    value={
                      (!findPassword.info && findPassword.mobile) ||
                      findPassword.verifyCode
                    }
                    onChange={t => {
                      dispatch({
                        type: 'login/setFindPassword',
                        findPassword: {
                          ...findPassword,
                          verifyCode: (findPassword.info && t.target.value) || '',
                          mobile: !findPassword.info
                            ? t.target.value
                            : findPassword.mobile,
                          tips: ''
                        }
                      });
                    }}
                    placeholder={
                      findPassword.info
                        ? intl.formatMessage({ id: 're_tel_validate' })
                        : intl.formatMessage({ id: 're_tel_number' })
                    }
                  />
                </div>
                <a
                  onClick={() => {
                    findPassword.domainName = domainName;
                    dispatch({
                      type: 'login/msmValidate',
                      payload: { ...findPassword, flag: 1 }
                    });
                  }}
                  disabled={msm.minutes < 61}
                >
                  {reSend}
                </a>
              </div>
            </TabPane>
          </Tabs>
          {
            checkCodeVisible && (
              <div className="activate-type active-checkcode">
                <div className="checkcode-input">
                  <i className="iconfont icon-room-shouquan" />
                  <input
                    type="text"
                    placeholder={intl.formatMessage({ id: 'index_login_check_code' })}
                    value={checkCode}
                    onChange={e =>
                      dispatch({
                        type: 'login/update',
                        payload: { checkCode: e.target.value }
                      })
                    }
                    maxLength="6"
                  />
                </div>
                <div className="code-area">
                  <img
                    src={checkCodeImg}
                    onClick={() => dispatch({ type: 'login/getCheckCode' })}
                  />
                </div>
              </div>
            )
          }
          <p className="register-case">{findPassword.tips}</p>
          <div className="retrieve-btn">
            <button
              disabled={
                !(
                  findPassword.verifyCode &&
                  findPassword.verifyCode.length === 6
                )
              }
              onClick={() => dispatch({ type: 'login/findPassword', flag: 1 })}
            >
              <FormattedMessage id="index_complete" />
            </button>
          </div>
          <div className="jump_link">
            <a
              className="lf"
              onClick={() =>
                dispatch({ type: 'login/setDivType', divType: OPEN_LOGIN })
              }
            >
              <FormattedMessage id="index_login2" />
            </a>
            {/* <a className="lr" onClick={() => dispatch({type: 'login/setDivType', divType: OPEN_SIGN})}><FormattedMessage
                id='index_register_account'/></a> */}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/login/FindPassword.js